import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './components/error/error.component';
import { LoggedoutComponent } from './components/loggedout/loggedout.component';
import { LoginComponent } from './components/login/login.component';
import { DefaultRouteGuard } from './security/default-route-guard.service';
import { AuthenticateGuard, PrivilegeGuard } from '@inera/common';

export const routes: Routes = [
  {
    path: 'start',
    loadChildren: () => import('./modules/select-module/select-module.module').then(m => m.SelectModuleModule),
  },
  {
    path: 'theme',
    loadChildren: () => import('./modules/theme/theme.module').then(m => m.ThemeModule),
    canActivate: [DefaultRouteGuard],
  },
  {
    path: 'validator',
    loadChildren: () => import('./modules/saml-validator/saml-validator.module').then(m => m.SamlValidatorModule),
  },
  {
    path: 'client-register',
    loadChildren: () => import('./modules/client-register/client-register.module').then(m => m.ClientRegisterModule),
    canActivate: [DefaultRouteGuard],
  },
  {
    path: 'sso-groups',
    loadChildren: () => import('./modules/sso-groups/sso-groups.module').then(m => m.SsoGroupsModule),
    canActivate: [AuthenticateGuard],
  },
  {
    path: 'privilege',
    loadChildren: () => import('./modules/privilege/privilege.module').then(m => m.PrivilegeModule),
    canActivate: [PrivilegeGuard],
    data: {
      privileges: [{ name: 'ADMIN', actions: ['READ', 'WRITE'] }],
    },
  },
  {
    path: '_error',
    component: ErrorComponent,
    data: { breadcrumb: { label: 'Felhantering' } },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'loggedout',
    component: LoggedoutComponent,
  },
  { path: '**', redirectTo: 'start' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppModule {}
